export enum DocumentCompletionStatusEnum {
  UNKNOWN = 'UNKNOWN',
  INCOMPLETE = 'INCOMPLETE',
  COMPLETED = 'COMPLETED',
}
